import React from 'react';
import { Divider as MuiDivider, DividerProps } from '@mui/material';

export const Divider: React.FC<DividerProps> = (props) => {
  return <MuiDivider {...props} />;
};
